import { observable, action} from 'mobx';
import equip from './equipSettings'
import {
    date,
    elevators,
    shipment,
    time,
    score,
    cropPlan,
    receptionBunkersStore,
    dcUnitsStore,
    storageStore, presets, transportStore, offers
} from '../index';
import Bunker from '../objects/bunker';
import Silos from '../objects/silos';
import oBunker from '../objects/outputBunker';
import ReceptionTransportStore from "../GameSessionStore/ReceptionTransportStore";
import Hopper from "../objects/hopper";
import CleaningUnit from "../objects/CleaningUnit";
import DryingUnit from "../objects/DryingUnit";

export default class PresetsStore {

    constructor(){
        this.inputEquip = equip.inputEquip;
        this.outputEquip  = equip.outputEquip;
        this.cleaningEquip = equip.cleaningEquip;
        this.dryingEquip = equip.dryingEquip;
        this.storageEquip = equip.storageEquip;
        this.infrastructure = 4000000;
        this.elevatorsName = '';
    }
    setElevatorsName(name){
        this.elevatorsName = name;
    }
    @observable gameCreate = false;
    @observable region;
    @observable inputEquip;
    @observable cleaningEquip;
    @observable dryingEquip;
    @observable storageEquip;
    @observable outputEquip;
    @observable infrastructure;

    @observable distributionCulture = {
        "wheat":0,
        "rape":0,
        "soy":0,
        "sunflower":0,
        "corn":0
    };
    @observable cultureHoldingPlan={
        "wheat":30,
        "rape":30,
        "soy":30,
        "sunflower":90,
        "corn":30
    };
    @observable culturePlan = {
        "wheat":0,
        "rape":0,
        "soy":0,
        "sunflower":0,
        "corn":0
    };
    @action incInfrastructure(value){
        this.infrastructure = value;
    }

    @action setElevatorsData(){
        cropPlan.constructor();
        time.constructor();
        offers.constructor();
        transportStore.constructor();
        date.constructor();
        shipment.constructor();
        let bunkers = this.inputEquip.filter((item)=>!!item.quantity);
        let result = [];
        let count = 0;
        bunkers.forEach((item)=>{
            for(let i = 0;i < item.quantity; i++) result.push(new Bunker(i,(+item.capacity), item.name))
            count+=item.quantity;
        });
        receptionBunkersStore.receptionBunker = result;

        let items = this.cleaningEquip.filter((item)=>!!item.quantity);
        result = [];
        count = 0;
        items.forEach((item)=>{
            for(let i = 0;i < item.quantity; i++) result.push(new CleaningUnit(i+count,item.name,{
                    wheat:item.wheatpercents,
                    rape:item.rapepercents,
                    soy:item.soypercents,
                    sunflower:item.sunflowerpercents,
                    corn:item.cornpercents,
                },
                {
                    wheat:item.wheateff,
                    rape:item.rapeeff,
                    soy:item.soyeff,
                    sunflower:item.sunflowereff,
                    corn:item.corneff,
                }
            ))
            count+=item.quantity;
        });
        dcUnitsStore.cleaningList = result;

        items = this.dryingEquip.filter((item)=>!!item.quantity);

        result = [];
        count = 0;
        items.forEach((item)=>{
            for(let i = 0;i < item.quantity; i++) result.push(new DryingUnit(i+count,item.name,{
                    wheat:item.wheatpercents,
                    rape:item.rapepercents,
                    soy:item.soypercents,
                    sunflower:item.sunflowerpercents,
                    corn:item.cornpercents,
                },
                {
                    wheat:item.wheateff,
                    rape:item.rapeeff,
                    soy:item.soyeff,
                    sunflower:item.sunflowereff,
                    corn:item.corneff,
                }
            ))
             count+=item.quantity;
        });
        dcUnitsStore.dryingList = result;

        items = this.storageEquip.filter((item)=>!!item.quantity && item.name !== "Хопер");
        result = [];

        count = 0;
        items.forEach((item)=>{
            for(let i = 0;i < item.quantity; i++) result.push(new Silos(i+count,+item.capacity,item.name))
             count+=item.quantity;
        });
        storageStore.silosList = result;

        items = this.storageEquip.filter((item)=>!!item.quantity && item.name === "Хопер");
        result = [];

        count = 0;
        items.forEach((item)=>{
            for(let i = 0;i < item.quantity; i++) result.push(new Hopper(i+count,+item.capacity,item.name))
             count+=item.quantity;
        });
        storageStore.hoppersList = result;

        items = this.outputEquip.filter((item)=>!!item.quantity);

        result = [];
        count = 0;
        items.forEach((item)=>{
            for(let i = 0;i < item.quantity; i++) result.push(new oBunker(i+count,item.type,item.name))
             count+=item.quantity;
        });

        shipment.shipmentBunker = result;

        const input = this.inputEquip.filter((item)=>item.quantity);
        const output = this.outputEquip.filter((item)=>item.quantity);
        const cleaning = this.cleaningEquip.filter((item)=>item.quantity);
        const drying = this.dryingEquip.filter((item)=>item.quantity);
        const storage = this.storageEquip.filter((item)=>(item.quantity && item.name !== "Хопер"));


        const totalCost = ()=>{
            let result = 0;
            input.forEach((item)=>{result+=item.quantity*(+item.price.replace(/[.| ]/gim,''))});
            output.forEach((item)=>{result+=item.quantity*(+item.price.replace(/[.| ]/gim,''))});
            cleaning.forEach((item)=>{result+=item.quantity*(+item.price.replace(/[.| ]/gim,''))});
            drying.forEach((item)=>{result+=item.quantity*(+item.price.replace(/[.| ]/gim,''))});
            storage.forEach((item)=>{result+=item.quantity*(+item.price.replace(/[.| ]/gim,''))});
            return result+this.infrastructure;
        };
        score.setElevatorsName(this.elevatorsName);

        cropPlan.totalWeight = {...this.culturePlan};
        cropPlan.currentWeight = {...this.culturePlan};
        cropPlan.initScenario();
        date.forecastInitialization();
        date.setCurrentDay();
        score.total = totalCost();
        time.startTime();
        this.inputEquip = equip.inputEquip;
        this.outputEquip  = equip.outputEquip;
        this.cleaningEquip = equip.cleaningEquip;
        this.dryingEquip = equip.dryingEquip;
        this.storageEquip = equip.storageEquip;
        this.gameCreate = true;
        this.region = -1;
        this.culturePlan = {
            "wheat":0,
            "rape":0,
            "soy":0,
            "sunflower":0,
            "corn":0
        };
        this.distributionCulture = {
            "wheat":0,
            "rape":0,
            "soy":0,
            "sunflower":0,
            "corn":0
        };
    }

    @action setRegion(region, distribution){
        this.distributionCulture = distribution;
        this.region = region;
    }

    @action setCulturePlan(id){
        for(let key in  this.culturePlan) {
            this.culturePlan[key] = this.storageEquip.reduce((sum, current) => (sum +(
                current.name !== "Хоппер"
                ?
                (+current.capacity * current.quantity)
                 :
                0
                )
            ), 0) * this.distributionCulture[key] * 5;
        }
    }
}



// WEBPACK FOOTER //
// ./src/shared/stores/presets/presetsStore.js